import React from 'react'

import { NextPage } from 'next'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import AutoInsuranceRedirect from 'experiences/products/AutoInsuranceRedirect'
import { MinimalLayout } from 'shared/layout/MinimalLayout'

const AutoRedirect: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<MinimalLayout metaTags={metaTags}>
		<AutoInsuranceRedirect />
	</MinimalLayout>
)

export const getServerSideProps = defaultSSRProps

export default AutoRedirect
